"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderListOfContacts = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderTwitter = twitter => {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "con-address__list--item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "con-link con-wrap",
    href: "https://twitter.com/" + twitter,
    target: "_blank",
    rel: "noreferrer noopener"
  }, '@' + twitter)));
};
const renderListOfContacts = (contacts, t) => {
  return /*#__PURE__*/_react.default.createElement("div", null, contacts.map(contact => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
      className: "con-heading__m"
    }, contact.name), /*#__PURE__*/_react.default.createElement("div", {
      className: "con-address-container"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "con-address__list"
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "con-address__list--item"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "con-text__xs"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "con-bold"
    }, t('Pages.Contact.Phone'), ": "), contact.phoneNum)), /*#__PURE__*/_react.default.createElement("li", {
      className: "con-address__list--item"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "con-text__xs"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "con-bold"
    }, t('Pages.Contact.Mobile'), ": "), contact.mobileNum)), /*#__PURE__*/_react.default.createElement("li", {
      className: "con-address__list--item"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "con-text__xs"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "con-link con-wrap",
      href: "mailto:" + contact.email
    }, contact.email))), contact.twitter && renderTwitter(contact.twitter))));
  }));
};
exports.renderListOfContacts = renderListOfContacts;